import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Upload, FileText, CreditCard, LayoutTemplate, MoreHorizontal } from "lucide-react";
import BottomNavItem from "./BottomNavItem";
import OverflowMenu from "./OverflowMenu";
import { useEditingState } from "@/contexts/EditingStateContext";
import { useTranslation } from "react-i18next";

const BottomNavigation = () => {
  const { t } = useTranslation();
  const [isOverflowMenuOpen, setIsOverflowMenuOpen] = useState(false);
  const location = useLocation();
  const { isEditing } = useEditingState();

  const handleOverflowClick = () => {
    setIsOverflowMenuOpen(true);
  };

  const handleOverflowClose = () => {
    setIsOverflowMenuOpen(false);
  };

  // Определяем активные состояния для навигационных элементов
  const isUploadActive = location.pathname === "/" || location.pathname === "/upload";
  const isRecordsActive = location.pathname === "/dashboard" || location.pathname.startsWith("/record/");
  const isTemplatesActive = location.pathname === "/templates" || location.pathname.startsWith("/templates/");
  const isBalanceActive = location.pathname === "/balance" || location.pathname === "/payment/result";

  // Скрываем навигацию во время редактирования
  if (isEditing) {
    return null;
  }

  return (
    <>
      {/* Bottom Navigation Bar - показывается только на мобильных устройствах */}
      <nav
        className="bottom-navigation fixed bottom-0 left-0 right-0 z-50 bg-card border-t border-border md:hidden"
        role="navigation"
        aria-label="Основная навигация"
        style={{
          paddingBottom: 'env(safe-area-inset-bottom, 0px)'
        }}
      >
        <div className="flex items-center justify-center px-2 py-1 w-full">
          <BottomNavItem
            to="/"
            icon={<Upload />}
            label={t('common.upload')}
            isActive={isUploadActive}
            aria-label={t('common.upload_file')}
          />

          <BottomNavItem
            to="/dashboard"
            icon={<FileText />}
            label={t('common.records')}
            isActive={isRecordsActive}
            aria-label={t('common.my_records')}
          />

          <BottomNavItem
            to="/templates"
            icon={<LayoutTemplate />}
            label={t('common.templates')}
            isActive={isTemplatesActive}
            aria-label={t('common.templates')}
          />

          <BottomNavItem
            to="/balance"
            icon={<CreditCard />}
            label={t('common.balance')}
            isActive={isBalanceActive}
            aria-label={t('common.balance_and_payment')}
          />

          <BottomNavItem
            icon={<MoreHorizontal />}
            label={t('common.more')}
            onClick={handleOverflowClick}
            aria-label={t('common.more')}
          />
        </div>
      </nav>

      {/* Overflow Menu */}
      <OverflowMenu
        isOpen={isOverflowMenuOpen}
        onClose={handleOverflowClose}
      />

      {/* Global CSS для responsive поведения - только один раз в DOM */}
      <style>{`
        /* Bottom Navigation показывается только на мобильных устройствах */
        .bottom-navigation {
          display: flex;
        }

        /* Скрывать Bottom Navigation на планшетах и десктопах */
        @media (min-width: 768px) {
          .bottom-navigation {
            display: none !important;
          }
        }
      `}</style>
    </>
  );
};

export default BottomNavigation;